import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
	name: "webSocketDate",
	standalone: false,
})
export class WebSocketDatePipe implements PipeTransform {
	transform(value: number | string | Date, ...args: unknown[]): Date {
		if (value instanceof Date) return value;

		if (typeof value === "string") return new Date(value);

		return new Date(value * 1000);
	}
}
